<template>
  <v-flex class="filter-balance">
    <v-btn
      v-for="({ label, value, active }, index) in filters"
      :key="index"
      @click="emitDateByFilter(value)"
      :color="active ? 'primary' : ''"
      :class="active ? 'white--text' : ''"
      class="btn-filter"
    >
      {{ label }}
    </v-btn>
  </v-flex>
</template>

<script>
import moment from 'moment'

export default {
  name: 'AppFilterBalance',
  props: {
    cleanFilters: {
      type: Boolean,
      default: () => false
    },
    futureMode: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    currentFilter: 60,
    canEmitDate: true
  }),
  watch: {
    cleanFilters: function (value) {
      if (value) {
        this.currentFilter = null
      }
    }
  },
  created() {
    this.emitDateByFilter(60)
  },
  computed: {
    filters() {
      return [
        {
          label: '30 dias',
          value: 30,
          active: this.currentFilter === 30
        },
        {
          label: '60 dias',
          value: 60,
          active: this.currentFilter === 60
        },
        {
          label: '90 dias',
          value: 90,
          active: this.currentFilter === 90
        },
        {
          label: '120 dias',
          value: 120,
          active: this.currentFilter === 120
        }
      ]
    }
  },
  methods: {
    emitDateByFilter(value) {
      this.currentFilter = value

      const dateStart = this.futureMode
        ? moment().toISOString()
        : moment().subtract(value, 'days').toISOString()
      const dateEnd = this.futureMode
        ? moment().add(value, 'days').toISOString()
        : moment().toISOString()

      const datesObject = { dateStart, dateEnd }

      this.$emit('dateRange', datesObject)
    }
  }
}
</script>

<style lang="stylus" scoped>
.filter-balance
  display: flex
  justify-content: flex-start
  align-items: center
  margin: 30px 0
  @media(max-width: 800px)
    flex-direction: column
  .btn-filter
    min-width: 164px
    min-height: 35px
    @media(max-width: 800px)
      min-width: 100%
    border: 1px solid var(--v-primary-base)
    color: var(--v-gray-darken4)
</style>
